var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSavedFilters(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 9,
    viewBox: "0 0 11 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.26562 3.60938V5.80078L4.29688 6.42383V3.60938V3.20117L4.59766 2.90039L6.44531 1.03125H1.0957L2.94336 2.87891L3.26562 3.20117V3.60938ZM0 0H1.03125H6.53125H7.5625V1.03125V1.375L5.32812 3.60938V7.04688V8.25L4.29688 7.62695L2.23438 6.35938V3.60938L0 1.375V1.03125V0ZM8.25 0.171875H8.76562H10.4844H11V1.20312H10.4844H8.76562H8.25V0.171875ZM7.39062 3.60938H10.4844H11V4.64062H10.4844H7.39062H6.875V3.60938H7.39062ZM7.39062 7.04688H10.4844H11V8.07812H10.4844H7.39062H6.875V7.04688H7.39062Z",
    fill: "#3A8FD8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSavedFilters);
export default __webpack_public_path__ + "static/media/saved-filters.14b900713a9923615965cfd9148eb865.svg";
export { ForwardRef as ReactComponent };